import { ReactComponent as CloseIcon } from "../../../assets/icons/closeIcon.svg";
import { ReactComponent as RadioIcon } from "../../../assets/icons/radioIcon.svg";

import CheckBox from "../../../components/common/checkBox";
import Button from "../../../../common/components/button";
import DayPickerInput from "../../../components/common/DayPickerInput";

import { useEffect, useRef, useState } from "react";
import { subMonths } from "date-fns";
import { useGetCommonDelivery } from "../../../../common/hooks/common/useGetCommonDelivery";
import { useGetOrderCustomer } from "../../../../common/hooks/console/transaction/useGetOrderCustomer";
import { useGetOrderBranch } from "../../../../common/hooks/console/transaction/useGetOrderBranch";
import PortalSelectBox from "../../../components/common/portalSelectBox";

interface FilterDetailProps {
    filterData: {
        start_date?: string;
        end_date?: string;
        order_status?: number[];
        payment_status?: number[];
        branch_type?: number[];
        selected_customers?: string[];
        selected_branches?: string[];
        selected_delivery?: string[];
        selected_customers_full?: string[];
        selected_branches_full?: string[];
    };
    onClose: () => void;
    onApplyFilter: (filterData: {
        start_date?: string;
        end_date?: string;
        order_status?: number[];
        payment_status?: number[];
        branch_type?: number[];
        selected_customers?: string[];
        selected_branches?: string[];
        selected_delivery?: string[];
        selected_customers_full?: string[];
        selected_branches_full?: string[];
    }) => void;
}

const FilterDetail = ({ onClose, onApplyFilter, filterData }: FilterDetailProps) => {
    const [selectedOption, setSelectedOption] = useState<string>("");
    const [startDate, setStartDate] = useState<Date | undefined>();
    const [endDate, setEndDate] = useState<Date | undefined>();
    const [orderStatus, setOrderStatus] = useState<number[]>([1, 2, 3, 4, 5, 6]);
    const [paymentStatus, setPaymentStatus] = useState<number[]>([1, 2]);
    const [branchType, setBranchType] = useState<number[]>([1, 2]);
    const [customerTxt, setCustomerTxt] = useState<string>("");
    const [branchTxt, setBranchTxt] = useState<string>("");
    const [deliveryTxt, setDeliveryTxt] = useState<string>("");
    const [selectedCustomers, setSelectedCustomers] = useState<{ value: string; label: string }[]>([]);
    const [selectedCustomerName, setSelectedCustomerName] = useState<string[]>([]);
    const [selectedBranches, setSelectedBranches] = useState<{ value: string; label: string }[]>([]);
    const [selectedBranchName, setSelectedBranchName] = useState<string[]>([]);
    const [selectedDelivery, setSelectedDelivery] = useState<{ value: string; label: string }[]>([]);
    const [selectedDeliveryName, setSelectedDeliveryName] = useState<string[]>([]);

    const filterRef = useRef<HTMLDivElement>(null);

    const { data: deliveryData } = useGetCommonDelivery(deliveryTxt);
    const { data: customerData } = useGetOrderCustomer(customerTxt);

    console.log(customerData);
    const { data: branchData } = useGetOrderBranch(branchTxt);
    const dateOptions = [
        { value: "today", label: "오늘", monthsAgo: 0 },
        { value: "month", label: "1개월", monthsAgo: 1 },
        { value: "threeMonths", label: "3개월", monthsAgo: 3 },
        { value: "sixMonths", label: "6개월", monthsAgo: 6 },
        { value: "year", label: "1년", monthsAgo: 12 },
    ];

    const handleDateSelection = (value: string, monthsAgo: number) => {
        const today = new Date();
        const calculatedStartDate = monthsAgo === 0 ? today : subMonths(today, monthsAgo);

        setSelectedOption(value);
        setStartDate(calculatedStartDate);
        setEndDate(today);
    };
    const toggleOrderStatus = (status: number) => {
        if (orderStatus.includes(status)) {
            setOrderStatus(prev => prev.filter(s => s !== status));
        } else {
            setOrderStatus(prev => [...prev, status]);
        }
    };
    const togglePaymentStatus = (status: number) => {
        if (paymentStatus.includes(status)) {
            setPaymentStatus(prev => prev.filter(s => s !== status));
        } else {
            setPaymentStatus(prev => [...prev, status]);
        }
    };

    const toggleBranchType = (type: number) => {
        if (branchType.includes(type)) {
            setBranchType(prev => prev.filter(s => s !== type));
        } else {
            setBranchType(prev => [...prev, type]);
        }
    };

    const applyFilter = () => {
        onApplyFilter({
            start_date: startDate?.toISOString().split("T")[0],
            end_date: endDate?.toISOString().split("T")[0],
            order_status: orderStatus,
            payment_status: paymentStatus,
            branch_type: branchType,
            selected_customers: selectedCustomers.map(c => c.value),
            selected_branches: selectedBranches.map(b => b.value),

            selected_customers_full: selectedCustomerName,
            selected_branches_full: selectedBranchName,
            selected_delivery: selectedDeliveryName,
        });

        onClose();
    };

    const handleCustomerSelect = (value: string, label: string) => {
        setSelectedCustomers(prev => {
            if (prev.some(customer => customer.value === value)) return prev;
            return [...prev, { value, label }];
        });

        setSelectedCustomerName(prev => {
            if (!prev.includes(label)) return [...prev, label];
            return prev;
        });
    };

    const handleRemoveCustomer = (value: string, label: string) => {
        setSelectedCustomers(prev => prev.filter(customer => customer.value !== value));
        setSelectedCustomerName(prev => prev.filter(name => name !== label));
    };
    const handleBranchSelect = (value: string, label: string) => {
        setSelectedBranches(prev => {
            if (prev.some(branch => branch.value === value)) return prev;
            return [...prev, { value, label }];
        });

        setSelectedBranchName(prev => {
            if (!prev.includes(label)) return [...prev, label];
            return prev;
        });
    };
    const handleRemoveBranch = (value: string, label: string) => {
        setSelectedBranches(prev => prev.filter(branch => branch.value !== value));
        setSelectedBranchName(prev => prev.filter(name => name !== label));
    };
    const handleDeliverySelect = (value: string, label: string) => {
        setSelectedDelivery(prev => {
            if (prev.some(delivery => delivery.value === value)) return prev;
            return [...prev, { value, label }];
        });

        setSelectedDeliveryName(prev => {
            if (!prev.includes(label)) return [...prev, label];
            return prev;
        });
    };
    const handleRemoveDelivery = (value: string, label: string) => {
        setSelectedDelivery(prev => prev.filter(delivery => delivery.value !== value));
        setSelectedDeliveryName(prev => prev.filter(name => name !== label));
    };

    const handleStartDateChange = (dateValue: Date | undefined) => {
        if (!dateValue) return;
        const adjustedDate = new Date(dateValue);
        adjustedDate.setMinutes(adjustedDate.getMinutes() - adjustedDate.getTimezoneOffset());
        setStartDate(adjustedDate);
        setSelectedOption("");
    };

    const handleEndDateChange = (dateValue: Date | undefined) => {
        if (!dateValue) return;
        const adjustedDate = new Date(dateValue);
        adjustedDate.setMinutes(adjustedDate.getMinutes() - adjustedDate.getTimezoneOffset());
        setEndDate(adjustedDate);
        setSelectedOption("");
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                filterRef.current &&
                !filterRef.current.contains(event.target as Node) &&
                !(event.target as HTMLElement).closest(".selectbox-dropdown")
            ) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    useEffect(() => {
        setStartDate(filterData.start_date ? new Date(filterData.start_date) : undefined);
        setEndDate(filterData.end_date ? new Date(filterData.end_date) : undefined);
        setOrderStatus(filterData.order_status || [1, 2, 3, 4, 5, 6]);
        setPaymentStatus(filterData.payment_status || [1, 2]);
        setBranchType(filterData.branch_type || [1, 2]);
        if (filterData.selected_customers) {
            const restored = filterData.selected_customers.map((id, i) => ({
                value: id,
                label: filterData.selected_customers_full?.[i] ?? id,
            }));
            setSelectedCustomers(restored);
            setSelectedCustomerName(filterData.selected_customers_full ?? []);
        }
        if (filterData.selected_branches) {
            const restored = filterData.selected_branches.map((id, i) => ({
                value: id,
                label: filterData.selected_branches_full?.[i] ?? id,
            }));
            setSelectedBranches(restored);
            setSelectedBranchName(filterData.selected_branches_full ?? []);
        }
        if (filterData.selected_delivery) {
            setSelectedDelivery(
                filterData.selected_delivery.map(name => ({
                    value: name,
                    label: name,
                })),
            );
            setSelectedDeliveryName(filterData.selected_delivery);
        }
        if (filterData.start_date && filterData.end_date) {
            const today = new Date();
            const startDate = new Date(filterData.start_date);

            const matchedOption = dateOptions.find(option => {
                const calculatedStartDate = option.monthsAgo === 0 ? today : subMonths(today, option.monthsAgo);
                return (
                    calculatedStartDate.toISOString().split("T")[0] === startDate.toISOString().split("T")[0] &&
                    filterData.end_date === today.toISOString().split("T")[0]
                );
            });

            setSelectedOption(matchedOption ? matchedOption.value : "");
        }
    }, [filterData]);

    return (
        <div ref={filterRef} className="w-[680px] bg-white rounded-2xl border shadow-lg">
            <div className="flex items-center justify-between px-5 py-6">
                <p className="text-2xl font-bold">상세필터</p>
                <CloseIcon className="cursor-pointer" onClick={onClose} />
            </div>
            <div className="bg-[#F6F7FA] flex flex-col gap-3 p-5 max-h-[60vh] overflow-y-auto">
                <div className="flex items-start">
                    <p className="w-[100px] text-sm text-gray2">배송일자</p>
                    <div className="w-full flex flex-col gap-2">
                        <div className="grid grid-cols-5 h-[34px]">
                            {dateOptions.map(option => (
                                <div
                                    key={option.value}
                                    className={`flex items-center w-full gap-2 cursor-pointer ${
                                        selectedOption === option.value ? "text-primary2" : "text-gray2"
                                    }`}
                                    onClick={() => handleDateSelection(option.value, option.monthsAgo)}
                                >
                                    {selectedOption === option.value ? (
                                        <RadioIcon className="w-8 h-8 -ml-1.5" />
                                    ) : (
                                        <div className="border-gray4 h-[19px] w-[19px] border-2 rounded-full" />
                                    )}
                                    <span className={`${selectedOption === option.value && "-ml-[7px]"}`}>{option.label}</span>
                                </div>
                            ))}
                        </div>
                        <div className="flex gap-3 relative z-50 bg-white h-[34px] px-3 border border-gray4 rounded-lg">
                            <DayPickerInput twoCalendar maxDate={endDate} initialDate={startDate} onDateChange={handleStartDateChange} />
                            <DayPickerInput twoCalendar minDate={startDate} initialDate={endDate} onDateChange={handleEndDateChange} />
                        </div>
                    </div>
                </div>
                <hr className="border-gray4" />
                <div className="flex items-start">
                    <p className="w-[100px] text-sm text-gray2">주문상태</p>
                    <div className="w-full text-base grid grid-cols-4  gap-2">
                        {["미확인", "접수완료", "준비완료", "배송완료", "취소", "보류"].map((label, index) => (
                            <CheckBox
                                key={index}
                                label={label}
                                checked={orderStatus.includes(index + 1)}
                                onChange={() => toggleOrderStatus(index + 1)}
                            />
                        ))}
                    </div>
                </div>
                <hr className="border-gray4" />
                <div className="flex items-center">
                    <p className="w-[100px] text-sm text-gray2">입금상태</p>
                    <div className="w-full text-base flex gap-2">
                        <CheckBox
                            className="w-[133px]"
                            label="입금"
                            checked={paymentStatus.includes(2)}
                            onChange={() => togglePaymentStatus(2)}
                        />
                        <CheckBox label="미입금" checked={paymentStatus.includes(1)} onChange={() => togglePaymentStatus(1)} />
                    </div>
                </div>
                <hr className="border-gray4" />
                <div className="flex items-center">
                    <p className="w-[100px] text-sm text-gray2">발주상태</p>
                    <div className="w-full text-base flex gap-2">
                        <CheckBox
                            className="w-[133px]"
                            label="본점"
                            checked={branchType.includes(1)}
                            onChange={() => toggleBranchType(1)}
                        />
                        <CheckBox label="타지점" checked={branchType.includes(2)} onChange={() => toggleBranchType(2)} />
                    </div>
                </div>
                <hr className="border-gray4" />
                <div className="flex flex-col">
                    <div className="flex items-center">
                        <p className="w-[100px] text-sm text-gray2">고객별</p>
                        <PortalSelectBox
                            onSearchChange={value => setCustomerTxt(value)}
                            onChange={value => {
                                const selectedOption = customerData?.find(customer => customer.customer_idx.toString() === value);
                                if (selectedOption) {
                                    handleCustomerSelect(value, selectedOption.customer_name);
                                }
                            }}
                            searchable
                            options={
                                customerData
                                    ? customerData.map(customer => ({
                                          value: customer.customer_idx.toString(),
                                          label: customer.customer_name,
                                      }))
                                    : []
                            }
                            className="w-full bg-white"
                            placeholder="미선택시 [전체]로 호출됩니다."
                            focusPlaceHolder="고객 검색 후 선택시, 복수선택이 가능합니다"
                            height="max-h-36"
                        />
                    </div>
                    <div className="flex flex-wrap gap-1 mt-1 ml-[86px]">
                        {selectedCustomers.map(customer => (
                            <div
                                key={customer.value}
                                className="px-2 py-1 rounded-3xl flex items-center bg-white border border-gray5 gap-1"
                            >
                                <p className="text-sm text-gray2">{customer.label}</p>
                                <CloseIcon
                                    className="w-4 h-4 cursor-pointer"
                                    onClick={() => handleRemoveCustomer(customer.value, customer.label)}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex flex-col gap-1">
                    <div className="flex items-center">
                        <p className="w-[100px] text-sm text-gray2">타지점별</p>
                        <PortalSelectBox
                            onSearchChange={value => setBranchTxt(value)}
                            onChange={value => {
                                const selectedOption = branchData?.find(branch => branch.customer_idx.toString() === value);
                                if (selectedOption) {
                                    handleBranchSelect(value, selectedOption.customer_name);
                                }
                            }}
                            searchable
                            options={
                                branchData
                                    ? branchData.map(branch => ({
                                          value: branch.customer_idx.toString(),
                                          label: branch.customer_name,
                                      }))
                                    : []
                            }
                            className="w-full bg-white"
                            placeholder="미선택시 [전체]로 호출됩니다."
                            focusPlaceHolder="타지점 검색 후 선택시, 복수선택이 가능합니다"
                            height="max-h-36"
                        />
                    </div>
                    <div className="flex flex-wrap gap-1 ml-[86px]">
                        {selectedBranches.map(branch => (
                            <div key={branch.value} className="px-2 py-1 rounded-3xl flex items-center bg-white border border-gray5 gap-1">
                                <p className="text-sm text-gray2">{branch.label}</p>
                                <CloseIcon
                                    className="w-4 h-4 cursor-pointer"
                                    onClick={() => handleRemoveBranch(branch.value, branch.label)}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex flex-col gap-1">
                    <div className="flex items-center">
                        <p className="w-[100px] text-sm text-gray2">배송업체별</p>
                        <PortalSelectBox
                            onSearchChange={value => setDeliveryTxt(value)}
                            onChange={value => {
                                const selectedOption = deliveryData?.data.find(delivery => delivery.delivery_idx.toString() === value);
                                if (selectedOption) {
                                    handleDeliverySelect(value, selectedOption.delivery_name);
                                }
                            }}
                            searchable
                            options={
                                deliveryData
                                    ? deliveryData.data.map(delivery => ({
                                          value: delivery.delivery_idx.toString(),
                                          label: delivery.delivery_name,
                                      }))
                                    : []
                            }
                            className="w-full bg-white"
                            height="max-h-24"
                            placeholder="미선택시 [전체]로 호출됩니다."
                            focusPlaceHolder="업체 검색 후 선택시, 복수선택이 가능합니다"
                        />
                    </div>
                    <div className="flex flex-wrap gap-1 ml-[86px]">
                        {selectedDelivery.map(delivery => (
                            <div
                                key={delivery.value}
                                className="px-2 py-1 rounded-3xl flex items-center bg-white border border-gray5 gap-1"
                            >
                                <p className="text-sm text-gray2">{delivery.label}</p>
                                <CloseIcon
                                    className="w-4 h-4 cursor-pointer"
                                    onClick={() => handleRemoveDelivery(delivery.value, delivery.label)}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-between px-6 h-[84px] gap-2">
                <Button
                    size="L"
                    className="w-full"
                    onClick={() => {
                        setOrderStatus([1, 2, 3, 4, 5, 6]);
                        setPaymentStatus([1, 2]);
                        setBranchType([1, 2]);
                        setStartDate(undefined);
                        setEndDate(undefined);
                        setSelectedOption("");
                    }}
                >
                    초기화
                </Button>
                <Button size="L" className="w-[480px] flex-shrink-0" status="regist" onClick={applyFilter}>
                    적용
                </Button>
            </div>
        </div>
    );
};

export default FilterDetail;
